// components/ChartErrorBoundary.tsx
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

/**
 * Fallback component displayed when chart fails to render
 */
function ChartFallback() {
  return (
    <div className="text-chariot-text-secondary bg-chariot-background-secondary/20 flex h-[300px] items-center justify-center rounded-lg">
      <div className="text-center">
        <InformationCircleIcon className="text-chariot-text-disabled mx-auto mb-2 h-8 w-8" />
        <p>Chart temporarily unavailable</p>
      </div>
    </div>
  );
}

interface ChartErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Error boundary wrapper for chart components
 * Uses react-error-boundary for functional component pattern
 */
export function ChartErrorBoundary({ children }: ChartErrorBoundaryProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ChartFallback}
      onError={(error, info) => {
        // Log chart rendering errors for monitoring
        console.error('Chart rendering failed:', error, info.componentStack);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
